import { LngLat } from "mapbox-gl";
import { observer } from 'mobx-react-lite';
import { useEffect, useMemo, useState } from 'react';
import { useParams } from "react-router-dom";
import useCircleWithRadiusOnMap from "../../hooks/useCircleWithRadiusOnMap";
import useNearestLocations from "../../hooks/useNearestLocations";
import useRadiusCompanyIdsOnMap from "../../hooks/useRadiusCompanyIdsOnMap";
import useProperty from "../../hooks/useProperty";
import { GeoCoordinate } from "../../interfaces/GeoCoordinate";
import { IDetailsTabProps } from "../../interfaces/IDetailsTabProps";
import { distinctBy } from "../../utils/utils";
import RadiusDropdown from "../RadiusDropdown";
import NearestLocationsGrid from "../locations/NearestLocationsGrid";

function PropertyDetailsCompaniesTab({ visible, setEntityCount }: IDetailsTabProps) {
    const { longitude, latitude } = useParams();
    const lngLat = useMemo(() => new LngLat(Number(longitude), Number(latitude)), [longitude, latitude]);
    const geoCoordinates = useMemo(() => new GeoCoordinate(lngLat.lat, lngLat.lng), [lngLat]);
    const property = useProperty(lngLat).property!;
    const [radius, setRadius] = useState(5);
    const nearestLocations = useNearestLocations(property.centerPoint, radius);
    useCircleWithRadiusOnMap(geoCoordinates, radius, visible, "PropertyDetailsCompaniesTab");
    useRadiusCompanyIdsOnMap(nearestLocations, visible);

    useEffect(() => setEntityCount(distinctBy(nearestLocations, l => l.pipedriveCompanyId).length), [nearestLocations, setEntityCount]);

    if (!visible)
        return null;

    return (
        <NearestLocationsGrid
            locations={nearestLocations}
            radiusDropdown={<RadiusDropdown value={radius} onChange={setRadius} />}
        />
    );
}

export default observer(PropertyDetailsCompaniesTab);
